import type { MODULATOR_LAST_POINT_CHART_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulator-last-point-chart-card/modulator-last-point-chart-card.fr.ts";

export const MODULATOR_LAST_POINT_CHART_CARD_ENGLISH_LOCALE = {
  title: "Last point received",
} satisfies typeof MODULATOR_LAST_POINT_CHART_CARD_FRENCH_LOCALE;
